export default __webpack_public_path__ + "static/media/SCP.79afe2b2.svg";